/*
 * @Description: 权限控制工具函数
 * @Author: snake
 * @LastEditor: snake
 * @Date: 2019-03-13 09:04:25
 * @LastEditTime: 2019-07-31 16:55:25
 */
import Cookies from 'js-cookie'
import store from '../store'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 1 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeCookie(name) {
  return Cookies.remove(name)
}

export function setCookie(name, value) {
  return Cookies.set(name, value, { expires: 1 })
}

export function getCookie(name) {
  return Cookies.get(name)
}

export function getDomain() {
  const debug = getCookie('debug')
  const domain = getCookie('domain')

  if (debug === 'icarephone' && domain) {
    return domain
  } else {
    return process.env.VUE_APP_BASE_API
  }
}

/**
 * @description: 拦截ajax请求，对参数进行签名，额外添加参数timestamp、token、sign参数
 * @param {object} config 用户
 * @return: object
 */
export function checkSign(config) {
  let param = config.method === 'post' ? config.data : config.param
  param = typeof param === 'object' ? param : {}
  if (store.getters.token) {
    param['token'] = Cookies.get(TokenKey) // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers['token'] =Cookies.get(TokenKey)
    // console.log(param['token'])
  }

  if (config.method === 'post') {
    config['data'] = JSON.stringify(param)
  } else {
    config['params'] = param
  }
  return config
}

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.name || route.root) {
    if (roles.indexOf(route.name) >= 0) {
      return true
    } else if (route.children) {
      for (let i = 0; i < route.children.length; i++) {
        const ele = route.children[i]
        if (roles.indexOf(ele.name) >= 0) {
          return true
        }
      }
    }
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
export function filterAsyncRouter(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param {NodeTree} routes 路由树形节点
 * @param {Array} roles 用户所赋予的路由权限
 */
export function filterAsyncRouterOther(routes, roles) {
  routes.forEach(ele => {
    if (ele.children && ele.children.length > 0) {
      filterAsyncRouterOther(ele.children, roles)
    } else {
      ele.disabled = ele.name && roles.indexOf(ele.name) < 0
    }
  })
  return routes
}

// 获取debug域名
export function getDebugDomain() {
  const domain = getCookie('domain')
  const debug = getCookie('debug')

  if (debug === 'icarephone' && domain) {
    return domain
  } else {
    return process.env.VUE_APP_BASE_API
  }
}
